import { render, staticRenderFns } from "./chooseRoof.vue?vue&type=template&id=19d6ba03&scoped=true"
import script from "./chooseRoof.vue?vue&type=script&lang=js"
export * from "./chooseRoof.vue?vue&type=script&lang=js"
import style0 from "./chooseRoof.vue?vue&type=style&index=0&id=19d6ba03&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6ba03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d6ba03')) {
      api.createRecord('19d6ba03', component.options)
    } else {
      api.reload('19d6ba03', component.options)
    }
    module.hot.accept("./chooseRoof.vue?vue&type=template&id=19d6ba03&scoped=true", function () {
      api.rerender('19d6ba03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps/chooseRoof.vue"
export default component.exports